import {
  Modal,
  Box,
  Text,
  Tabs,
  // ScrollArea,
  Group,
  ActionIcon,
} from "@mantine/core";
import { estadoInicialProyecto, type IModalProyectoVistaProps } from "../interfaces";
import React from "react";
import { IconArrowsMaximize, IconArrowsMinimize, IconFilePencil, IconFileText, IconSettingsUp, IconUsers } from "@tabler/icons-react";
import ClientesCV from "../../clientes/controladorVista/clientesCV";
import FormularioInformacionProyectoVista from "./formularioInformacionProyectoVista";
import ContratosCV from "../../contratos/controladorVista/contratosCV";
import EquiposCV from "../../equipos/controladorVista/equiposCV";
import { useProyecto } from "../contextoProyecto";
import { ProveedorCargando } from "../../../globales/contextos/cargandoContext";

const ModalProyectoVista: React.FunctionComponent<IModalProyectoVistaProps> = ({
  abrir,
  guardarEditarProyecto,
  manejarCambioValorProyecto,
  abrirModalProyecto,
  entidadesRegistro,
  agregarError,
  errores,
  regexLat,
  regexLng
}) => {
  const { proyecto } = useProyecto();
  const [pantallaCompleta, setPantallaCompleta] = React.useState(false);

  return (
    <Modal
      closeOnClickOutside={false}
      opened={abrir}
      styles={{
        header: { backgroundColor: '#0074d914' }
      }}
      onClose={() => abrirModalProyecto(false, estadoInicialProyecto)}
      fullScreen={pantallaCompleta}
      title={
        <Group justify="space-between" w="100%">
          <Text fw={500} fz="lg">
            {proyecto.Id ? "Editar Proyecto" : "Agregar Proyecto"}
          </Text>
          <ActionIcon
            variant="light"
            onClick={() => setPantallaCompleta(!pantallaCompleta)}
          >
            {pantallaCompleta ? <IconArrowsMinimize size={18} /> : <IconArrowsMaximize size={18} />}
          </ActionIcon>
        </Group>
      }
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 1,
        zIndex: 4000,
      }}
      zIndex={4000}
      centered
      size={pantallaCompleta ? "100%" : "90%"}
      radius="md"
      withCloseButton
    >
      <Box style={{ display: "flex", flexDirection: "column" }}>
        <Tabs
          defaultValue={'InformacionProyecto'}
          keepMounted={false}
          style={{ flex: "0 0 auto" }}>
          <Tabs.List
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              background: "#fff",
            }}
          >
            <Tabs.Tab value="InformacionProyecto" leftSection={<IconFileText size={15} />}>
              Información Proyecto
            </Tabs.Tab>
            <Tabs.Tab
              disabled={proyecto.Id === 0}
              value="Clientes"
              leftSection={<IconUsers size={15} />}>
              Clientes
            </Tabs.Tab>
            <Tabs.Tab
              disabled={proyecto.Id === 0}
              value="Contratos" leftSection={<IconFilePencil size={15} />}>
              Contratos
            </Tabs.Tab>
            <Tabs.Tab
              disabled={!proyecto.ContratoId}
              value="Equipos"
              leftSection={<IconSettingsUp size={15} />}>
              Equipos
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="InformacionProyecto" >
            <ProveedorCargando>
              <FormularioInformacionProyectoVista
                manejarCambioValorProyecto={manejarCambioValorProyecto}
                entidadesRegistro={entidadesRegistro}
                abrirModalProyecto={abrirModalProyecto}
                guardarEditarProyecto={guardarEditarProyecto}
                agregarError={agregarError}
                errores={errores}
                regexLat={regexLat}
                regexLng={regexLng}
                pantallaCompleta={pantallaCompleta}
              />
            </ProveedorCargando>
          </Tabs.Panel>

          <Tabs.Panel value="Clientes">
            <Box
              style={{
                flex: 1,
                height: pantallaCompleta ? '80vh' : '65vh', // Alto consistente
                overflow: "auto", // Importante: el scroll será interno
              }}
            >
              <ProveedorCargando>
                <ClientesCV
                  pantallaCompleta={pantallaCompleta} />
              </ProveedorCargando>
            </Box>
          </Tabs.Panel>

          <Tabs.Panel value="Contratos">
              <Box
                style={{
                  flex: 1,
                  height: pantallaCompleta ? '80vh' : '65vh',
                  overflow: "auto", // El scroll será interno de la tabla o el formulario
                }}
              >
                <ProveedorCargando>
                  <ContratosCV pantallaCompleta={pantallaCompleta} />
                </ProveedorCargando>
              </Box>
            </Tabs.Panel>

          <Tabs.Panel value="Equipos" style={{ display: 'flex', flexDirection: 'column' }}>
            <Box
              style={{
                // Aquí le damos el alto que debe ocupar dentro del modal
                height: pantallaCompleta ? '75vh' : '55vh',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden', // Esto evita el scroll del modal
              }}
            >
              <ProveedorCargando>
                <EquiposCV pantallaCompleta={pantallaCompleta} idProyecto={proyecto.Id} />
              </ProveedorCargando>
            </Box>
          </Tabs.Panel>
        </Tabs>
      </Box>


    </Modal>
  );
};

export default ModalProyectoVista;
